import React from "react";
import { useParams } from "react-router-dom";
import { Collapse, Flex, Space, Typography } from "antd";
import {
  CreditCardOutlined,
  DollarCircleOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { OnlinePaymentMethods } from "./OnlinePaymentMethods";
import { OfflinePaymentMethods } from "./OfflinePaymentMethods";

const { Title } = Typography;

export const PaymentConfigList: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const sellerCode = decodeURIComponent(id ?? "");

  return (
    // Sin padding propio: el layout ya lo pone, y con el de acá el título quedaba más abajo que en
    // el resto de las páginas (xcons-docs#509).
    <div>
      {/* El ícono del menú, como el resto de los títulos de página. */}
      <Flex align="center" gap={8} style={{ marginBottom: 20 }}>
        <DollarCircleOutlined style={{ fontSize: 22 }} />
        <Title level={3} style={{ margin: 0 }}>
          Pagos
        </Title>
      </Flex>

      {/* #635: Online (pasarelas) y Offline (el ABM del seller), como las secciones de la
          Configuración del store: las dos abiertas al entrar. Cada una es un listado que se edita
          en el panel lateral (xcons-docs#636). */}
      <Collapse
        defaultActiveKey={["online", "offline"]}
        items={[
          {
            key: "online",
            label: (
              <Space size={8} style={{ fontWeight: 600 }}>
                <CreditCardOutlined />
                Online
              </Space>
            ),
            styles: { header: { height: 40, alignItems: "center" } },
            children: <OnlinePaymentMethods sellerCode={sellerCode} />,
          },
          {
            key: "offline",
            label: (
              <Space size={8} style={{ fontWeight: 600 }}>
                <WalletOutlined />
                Offline
              </Space>
            ),
            styles: { header: { height: 40, alignItems: "center" } },
            children: <OfflinePaymentMethods sellerCode={sellerCode} />,
          },
        ]}
      />
    </div>
  );
};
